<script>
import CollapseItem from 'element-ui/lib/collapse-item';

export default CollapseItem;
</script>

<style lang="scss">
@import '../../stylesheets/element-theme/collapse-item.css';

.el-collapse-item {
  &__arrow {
    @include rtl() {
      transform: rotate(180deg);
      margin: 0 auto 0 8px;
    }
  }

  &__arrow.is-active {
    @include rtl() {
      transform: rotate(90deg);
      margin: 0 auto 0 8px;
    }
  }
}
</style>
